import { Dialog, DialogContent, DialogTitle, DialogHeader } from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";
import { Badge } from "@/components/ui/badge";

export default function ViewOnlineOrderDiscountOfferModal({ isOpen, onClose, offer }) {
  if (!offer) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[700px] bg-cblack4 text-cwhite border-neutral-800">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-cwhite">
            Offer Details
          </DialogTitle>
        </DialogHeader>
        <Separator className="bg-neutral-800 my-2" />

        <div className="flex flex-col gap-6 py-2">
          {/* Header Info */}
          <div className="flex justify-between items-start">
            <div>
              <h2 className="text-lg font-bold text-cyellow">{offer.name}</h2>
              <p className="text-sm text-gray-400 mt-1">{offer.description || "No description provided."}</p>
            </div>
            <Badge
              variant={offer.status === "active" ? "success" : "destructive"}
              className={
                offer.status === "active"
                  ? "bg-emerald-500/20 text-emerald-400 border border-emerald-500/30"
                  : "bg-red-500/20 text-red-400 border border-red-500/30"
              }
            >
              {offer.status ? offer.status.toUpperCase() : "INACTIVE"}
            </Badge>
          </div>

          <Separator className="bg-neutral-800" />

          {/* Spend Threshold Condition */}
          <div>
            <h3 className="font-semibold text-cwhite mb-2 flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full bg-blue-500 inline-block"></span>
              Online Order Spend Condition
            </h3>
            <p className="text-sm text-gray-300">
              Customer must spend <span className="font-bold text-cyellow">£{offer.spend_threshold}</span> or more online to qualify.
            </p>
          </div>

          {/* Discount Section */}
          <div className="bg-cblack3 border border-neutral-800 rounded-lg p-4 flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div>
              <h3 className="font-semibold text-cwhite">Offer Reward</h3>
              <p className="text-xs text-gray-400 mt-1">The discount applied to this offer</p>
            </div>
            <div className="flex items-center gap-4">
              <div className="text-right">
                <span className="text-xs text-gray-400 block capitalize">Discount Type</span>
                <span className="text-sm font-semibold text-cwhite capitalize">{offer.discount_type || "percentage"}</span>
              </div>
              <div className="h-8 w-[1px] bg-neutral-800" />
              <div className="text-right">
                <span className="text-xs text-gray-400 block">Value</span>
                <span className="text-lg font-bold text-cyellow">
                  {offer.discount_type === "fixed"
                    ? `£ ${Number(offer.discount_value || 0).toFixed(2)}`
                    : `${offer.discount_value || 0}%`}
                </span>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
